var map = {
	"./bg.json": [
		4378,
		[
			378
		]
	],
	"./de.json": [
		5894,
		[
			894
		]
	],
	"./en.json": [
		4174,
		[
			174
		]
	],
	"./it.json": [
		3672,
		[
			672
		]
	],
	"./ro.json": [
		2354,
		[
			354
		]
	],
	"./tr.json": [
		9755,
		[
			755
		]
	],
	"./uk.json": [
		2749,
		[
			749
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 327;
module.exports = webpackAsyncContext;